import { render, staticRenderFns } from "./sync-error.vue?vue&type=template&id=061b669b"
import script from "./sync-error.vue?vue&type=script&lang=js"
export * from "./sync-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports